export class RateLimitError extends Error {
  retryAfter: number | null;
  constructor(message: string, retryAfter: number | null = null) {
    super(message);
    this.name = 'RateLimitError';
    this.retryAfter = retryAfter;
  }
}

export class ThreatCatAuthError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'ThreatCatAuthError';
  }
}

export class ApiError extends Error {
  status: number;

  constructor(message: string, status: number) {
    super(message);
    this.name = 'ApiError';
    this.status = status;
  }
}

/** Parse a FastAPI error response and throw the right Error subclass. */
export async function throwApiError(response: Response, fallback: string): Promise<never> {
  const body = await response.json().catch(() => ({ detail: fallback }));
  const detail: string = body.detail || fallback;
  if (response.status === 429) {
    const retryAfter = parseInt(response.headers.get('Retry-After') || '0') || null;
    throw new RateLimitError(detail, retryAfter);
  }
  if (response.status === 401 && /threatcat/i.test(detail) && /expired|invalid.*cookie/i.test(detail)) {
    throw new ThreatCatAuthError(detail);
  }
  throw new ApiError(detail, response.status);
}
